import React, { useEffect, useRef, useState } from 'react';
import {
    CCard, CCardBody, CButton, CModal, CModalHeader, CModalTitle,
    CModalBody, CModalFooter, CRow, CCol, CFormLabel, CFormInput, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem,
    CSpinner,
    CBadge
} from '@coreui/react';
import AddLabForm from './AddLabForm';
import LabCRUD from "../../services/general/LabsAPI.api.js";
import Carder from '../../components/shared/Carder';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api';
import GetDiagnosisData from '../../services/general/getDiagnosisData.api';
import HighlightedText from '../../components/shared/HighlightedText';
import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat';
import moment from 'moment';
import { Calendar, Plus, X } from 'lucide-react';
const ProviderPatientLabs = ({ patientID, loading, setLoading, setDataId, addDiagnosisIdsToNote, saveTreatsShell, setAllLabs, allLabs, diagnosis, updatePatientDiagnosis, noteStructureRef, showComment }) => {

    console.log(noteStructureRef, setDataId, 'noteStructureRef,setDataId')


    const [modalVisible, setModalVisible] = useState(false);
    const [currentDate, setCurrentDate] = useState('');
    const [newLabs, setNewLabs] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [labList, setLabList] = useState([]);
    const [possibleDiagnosis, setPossibleDiagnosis] = useState([]);
    const [date, setDate] = useState('');
    const [diagnosisModalVisible, setDiagnosisModalVisible] = useState(false)
    const [deleteVisibleId, setDeleteVisibleId] = useState(null)
    const [noteEditedLabId, setNoteEditLabId] = useState("")
    const [allDiagnosisListMaster, setAllDiagnosisListMaster] = useState([])
    const [selectedLabsToEdit, setSelectedLabsToEdit] = useState(null)

    useEffect(() => {
        setCurrentDate(getFormattedDate());
        fetchLabs();
        fetchPatientLabs()
    }, [patientID]);

    const fetchLabs = async () => {
        let labData = await LabCRUD("GETALL", "{}");
        labData = JSON.parse(labData.d)?.Data;
        setLabList(labData);
    };


    const getDiagnosisMaster = async () => {

        try {
            let response = await GetDiagnosisData("");
            let diagnosis = JSON.parse(response.d)?.Data;
            const options = diagnosis.map((item) => ({
                id: item.id,
                name: item.Name,
            }));
            setAllDiagnosisListMaster(options);
        } catch (error) {
            console.error("Error updating diagnosis options:", error);
        }

    };

    useEffect(() => {
        getDiagnosisMaster()
    }, [])


    const fetchPatientLabs = async () => {
        try {
            let formattedData
            formattedData = await PatientLabsCRUD('GET', patientID.toString());
            formattedData = JSON.parse(formattedData?.d)
            formattedData = formattedData?.Data || []
            if (formattedData) {
                formattedData = formattedData?.map((item) => {
                    return {
                        ...item,
                        data: JSON.parse(item.data)
                    }
                })
            }
            console.log(formattedData, 'formattedData')
            formattedData.sort((a, b) => b.id - a.id);
            // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));
            setAllLabs(formattedData)
            return formattedData;
        } catch (error) {
            console.log(error)
        }
    }

    const getFormattedDate = (dateStr) => {
        const today = dateStr ? new Date(dateStr) : new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();
        return `${mm}.${dd}.${yyyy}`;
    };

    const addLabToList = (lab) => {
        setNewLabs(lab);
    };
    // rgb(254, 255, 230)

    const handleSaveLabs = async () => {
        if (newLabs.length === 0) {
            toast.error('Please add the labs', toastConfig)
            return
        }
        try {
            if (selectedLabsToEdit) {
                await PatientLabsCRUD('UPDATE', patientID.toString(), JSON.stringify(newLabs), "", selectedLabsToEdit.id.toString(),)
                await fetchPatientLabs()
                setModalVisible(false);
                setSelectedLabsToEdit(null)
                setNewLabs([]);
                setDiagnosisModalVisible(false)
                toast.success('Successfully Updated', toastConfig)
            }
            else {
                await PatientLabsCRUD('INSERT', patientID.toString(), JSON.stringify(newLabs), getFormattedDate(date), "")
                setModalVisible(false);
                setSelectedLabsToEdit(null)
                setNewLabs([]);
                setDiagnosisModalVisible(false)
                const allLabs = await fetchPatientLabs()
                if (allLabs.length > 0) {
                    // setNoteEditLabId(allLabs[allLabs.length - 1]?.id) //could be this
                    setNoteEditLabId(allLabs[0]?.id) // could be this
                    noteStructureRef.current = {
                        ...noteStructureRef.current,
                        metadata: {
                            ...noteStructureRef.current.metadata,
                            labId: allLabs[0]?.id
                        }
                    }
                    await saveTreatsShell(false)
                }
                toast.success('Successfully Added', toastConfig)
            }
        } catch (error) {
            console.log(error)
        }
    };

    console.log(allLabs, noteEditedLabId, 'allLabs,noteEditedLabId')

    const handleAddButtonFirst = () => {
        filterDiagnosis()
    }

    const filterDiagnosis = async () => {
        if (newLabs.length === 0) {
            toast.error('Please add the labs', toastConfig)
            return
        }
        const allLab = newLabs
            .map(item => item.diagnosis)
            .filter(item => item !== '')
            .flatMap(item => item.split(',').map(d => d.trim())); // Split by comma and trim spaces

        const uniqueLabDiagnosis = [...new Set(allLab)].filter(Boolean);

        const diagnosisNotInPatient = uniqueLabDiagnosis.filter(labDiag => !diagnosis.includes(labDiag));

        console.log(diagnosisNotInPatient, 'diagnosisNotInPatient')

        if (diagnosisNotInPatient.length > 0) {
            setDiagnosisModalVisible(true)
            setPossibleDiagnosis(diagnosisNotInPatient.map(d => ({ Name: d })))
        } else {
            handleSaveLabs()
        }

    };


    const addDiagnosis = () => {

        let newDiagnosis = possibleDiagnosis.map(obj => {
            return obj.Name.trim();
        });

        console.log(possibleDiagnosis, 'add labs 1')

        let historyDiagnosis = newDiagnosis.reduce((acc, item) => {
            let existingData = noteStructureRef.current?.information?.[item] || [];
            let labName = newLabs.find(lab => lab.diagnosis === item)

            if (!existingData.includes(`Labs(${labName?.name})`)) {
                acc[item] = [...existingData, `Labs(${labName?.name})`];
            } else {
                acc[item] = existingData;
            }
            return acc;
        }, {});

        if (possibleDiagnosis.length > 0) {
            const allDiagnosisIdsToAdd = allDiagnosisListMaster
                .filter(master => possibleDiagnosis.some(possible => possible.Name === master.name))
                .map(matched => matched.id);

            if (addDiagnosisIdsToNote) {
                addDiagnosisIdsToNote(allDiagnosisIdsToAdd)
            }

        }
        noteStructureRef.current = {
            ...noteStructureRef.current,
            information: {
                ...noteStructureRef.current.information,
                ...historyDiagnosis
            }
        };
        newDiagnosis = newDiagnosis.join(',');
        updatePatientDiagnosis(patientID, newDiagnosis);
        setModalVisible(false);
        handleSaveLabs()
    };

    const handleClose = () => {
        setModalVisible(false)
        setSelectedLabsToEdit(null)
    }

    const handleEditLabs = (lab) => {
        setSelectedLabsToEdit(lab)
        setModalVisible(true)
    }

    const handleDeleteLabs = async (id) => {
        await PatientLabsCRUD('DELETE', patientID.toString(), "", "", deleteVisibleId?.toString());
        setDeleteVisibleId(null)
        await fetchPatientLabs()
    }
    const handleRemoveDiagnosis = (indexToRemove) => {
        setPossibleDiagnosis(prevDiagnosis => prevDiagnosis.filter((_, index) => index !== indexToRemove));
    };

    const handleAddLabs = () => {
        console.log('running')
        if (allLabs.length > 0 && noteEditedLabId) {
            const findEditNoteLab = allLabs.find(lab => lab.id === noteEditedLabId)
            if (findEditNoteLab) {
                handleEditLabs(findEditNoteLab)
                // setModalVisible(true)
                // setSelectedLabsToEdit(findEditNoteLab)
            } else {
                setModalVisible(true)
            }
        }
        else {
            setModalVisible(true)
        }
    }

    // handle edit labs only which linked to this setdataid
    useEffect(() => {
        const labId = noteStructureRef.current?.metadata?.labId
        console.log(noteStructureRef.current?.metadata?.labId, 'noteStructureRef.current?.metadata?.labId')
        setNoteEditLabId(labId)
    }, [])

    // useEffect(() => {
    // }, [noteEditedLabId])

    return (
        <>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                    <CSpinner color="primary" />
                </div>
            ) : (
                <>

                    {/* delete modal */}
                    <CModal
                        visible={deleteVisibleId}
                    >
                        <CModalHeader>
                            <CModalTitle>Warning</CModalTitle>
                        </CModalHeader>
                        <CModalBody>
                            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
                        </CModalBody>
                        <hr className="p-0 m-0" />
                        <CModalFooter className="p-3 m-0">
                            <CButton
                                onClick={() => {
                                    setDeleteVisibleId(null)
                                }}
                                className="text-white" color="secondary">Close</CButton>
                            <CButton onClick={handleDeleteLabs} className="text-white" color="danger">Delete</CButton>
                        </CModalFooter>
                    </CModal>


                    <CModal
                        className="dashboard-dark-modal patient-theme-modal patient-labs-modal"
                        size="lg"
                        visible={diagnosisModalVisible}
                        onClose={() => setDiagnosisModalVisible(false)}
                    >
                        <CModalHeader onClose={() => setDiagnosisModalVisible(false)}>
                            <CModalTitle>Diagnosis Details</CModalTitle>
                        </CModalHeader>
                        <CModalBody>
                            <div className="d-flex">
                                {/* <div style={{ minWidth: "50%", width: "50%" }} className="flex-fill me-3 text-display">
                                    <p style={{ whiteSpace: 'pre-line' }}></p> */}
                                {/* <HighlightedText text={textFormatInput} keywords={Array.from(detectedKeywordsRef.current)}></HighlightedText> */}
                                {/* </div> */}
                                <div className="flex-fill">
                                    <h5>Detected Diagnosis</h5>
                                    {/* {possibleDiagnosis.map((diagnosis, index) => (
                                        <CBadge key={index} color="info" className="me-2 mr-1 mb-1" style={{ cursor: 'pointer' }}
                                            onClick={() => handleRemoveDiagnosis(index)}>
                                            {diagnosis.Name}
                                        </CBadge>
                                    ))} */}
                                    {possibleDiagnosis.map((diagnosis, index) => (
                                        <CBadge key={index} color="info" className="d-flex align-items-center gap-2 me-2 mr-1 mb-1 text-white" style={{ cursor: 'pointer', width: 'fit-content', maxWidth: '100%' }}>
                                            {diagnosis.Name}
                                            <X onClick={() => { handleRemoveDiagnosis(index) }} size={15} />
                                        </CBadge>
                                    ))}
                                    <hr />
                                    <h5>Existing Diagnosis</h5>
                                    {diagnosis.map((diagnosisItem, index) => (
                                        <CBadge key={index} color="primary" className="me-2 mr-1 mb-1">
                                            {diagnosisItem}
                                        </CBadge>
                                    ))}
                                </div>
                            </div>
                        </CModalBody>
                        <CModalFooter>
                            <CButton variant='outline' color="primary" onClick={addDiagnosis}>Add Diagnosis</CButton>
                            <CButton variant='outline' color="secondary" onClick={handleSaveLabs}>Continue without adding</CButton>
                        </CModalFooter>
                    </CModal>

                    {/* <CNav className="justify-content-center" variant='pills'>
                        <CNavItem>
                            <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                                Manual Entry
                            </CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>
                                File Upload
                            </CNavLink>
                        </CNavItem>
                    </CNav> */}
                    <CTabContent className='overflow-hidden' >
                        <CTabPane visible={activeTab === 0}>
                            {/* <CButton style={{ marginTop: "10px" }} className='' onClick={handleAddLabs} variant="outline" color="primary">
                                + Add Labs
                            </CButton> */}
                            <CAccordion activeItemKey={2}>
                                <CAccordionItem itemKey={1}>
                                    <CAccordionHeader>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <p style={{ fontSize: "1rem" }} className='m-0 p-0 font-weight-medium text-capitalize'>Labs</p>
                                            {/* <CFormLabel
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    e.preventDefault()
                                                    handleAddLabs()
                                                }}
                                                className="d-flex p-0 m-0 flex-column align-items-center justify-content-center mt-1 shadow "
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    borderRadius: "20px",
                                                    background: "var(--ui-color-primary, #2b7cd3)",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <Plus className="text-white" strokeWidth={2} size={15} />
                                            </CFormLabel> */}
                                        </div>
                                    </CAccordionHeader>
                                    <CAccordionBody>
                                        
                            <div className='d-flex flex-column gap-4'>
                                {allLabs && allLabs?.sort((a, b) => a.id - b.id)?.map((labEntry, index) => {
                                return (
                                    <div>
                                        <span className='d-flex gap-2 align-items-center'>
                                            <Calendar size={15} />
                                            <p className='p-0 m-0'>Date : {new Date(labEntry.date).toLocaleDateString('en-US', {
                                            month: '2-digit',
                                            day: '2-digit',
                                            year: 'numeric'
                                        })}</p>
                                        </span>
                                        {labEntry.data?.map((lab, labIndex) => {
                                            console.log(lab,'labing')
                                            const value = lab.value ? parseFloat(lab.value) : null;
                                            const rangeParts = lab.range ? lab.range.split('-').map(part => parseFloat(part.trim())) : [];
                                            console.log(rangeParts,'rangeParts')
                                            const isValueInRange = value !== null && rangeParts.length === 2 && value >= rangeParts[0] && value <= rangeParts[1];
                                            return(
                                                 <div key={labIndex} style={{color:isValueInRange ? "orange" : ''}}>
                                                            <p className='m-0 p-0'>{lab.name} {lab.value || '-'} {lab?.unit}</p>
                                                            {/* <p className='m-0 p-0'>Reference Range : {lab.range}</p> */}
                                                            {/* <p className='m-0 p-0'>Value : {lab.value || '-'}</p>
                                                            <p className='m-0 p-0'>Diagnosis : {lab.diagnosis}</p>
                                                            <p className='m-0 p-0'>Remark : {lab.remark}</p>
                                                            <p className='m-0 p-0'>Plan Remark : {lab.planRemark}</p> */}
                                                        </div>
                                            )
                                        })}
                                    </div>

                                )
                            })}
                            </div>
                                    </CAccordionBody>
                                </CAccordionItem>
                            </CAccordion>

                        </CTabPane>
                    </CTabContent>
                </>
            )
            }

            <CModal className="dashboard-dark-modal patient-theme-modal patient-labs-modal" size="lg" scrollable backdrop={'static'} visible={modalVisible} onClose={handleClose}>
                <CModalHeader onClose={handleClose}>
                    <CModalTitle>{selectedLabsToEdit ? 'Update Patient Labs ' : 'Add Patient Labs '}</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <CRow>
                        <CCol className='d-flex flex-column' md={6}>
                            <CFormLabel>Date</CFormLabel>
                            <CustomDatePickingFormat
                                value={date}
                                onChange={(e) => setDate(e)}
                            />
                            {/* <CFormInput type="date" value={date} onChange={(e) => setDate(e.target.value)} /> */}
                        </CCol>
                    </CRow>
                    <AddLabForm selectedLabsToEdit={selectedLabsToEdit} labList={labList} addLabsFn={addLabToList} showComment={showComment} />

                </CModalBody>
                <CModalFooter>
                    <CButton variant="outline" color="primary" onClick={handleAddButtonFirst}>Add Patient Labs </CButton>
                    <CButton variant="outline" color="secondary" onClick={handleClose}>Cancel</CButton>
                </CModalFooter>
            </CModal>
        </>
    );
};

export default ProviderPatientLabs;
